<script lang="ts">
    import { getContext } from 'svelte'
    import { derived as sderived } from 'svelte/store'

    import Icon from '@iconify/svelte'

    import { gettext as _ } from 'hydria/services/gettext'
    import { numberToVisual } from 'hydria/utils/numbers'

    import type { ArcServices, DomainHandler } from './domain'

    import Date from 'hydria/components/Date.svelte'

    const Domain = getContext('Domain') as DomainHandler
    const status = sderived(Domain.status, ($status) => $status)

    // let arcServices: ArcServices | null = $derived(sderived(Domain.arcServices, ($v) => $v as ArcServices | null))
    let inAs = sderived(Domain.arcServices, ($v) => $v)
    let arcServices: ArcServices | null = $derived($inAs)
    let services = $derived(arcServices != null ? arcServices.tags : [])

    const serviceTexts = {
        'cpanel-ns': 'DNS sur cPanel',
        'cpanel-mx': 'Courriels sur cPanel',
        'cpanel-web': 'Web sur cPanel',
        // 'hydria-1': 'Web sur Hydria (serveur 1)',
        // 'hydria-2': 'Web sur Hydria (serveur 2)',
        'webdomaine-ns': 'DNS sur WebDomaine',
    }

    let updating: boolean = $state(false)

    async function updateServices() {
        updating = true
        await Domain.updateArcServices()
        updating = false
    }
</script>

<style>
    .sdata {
        display: flex;
        flex-direction: column;
        gap: 0.25em;
        font-size: 0.85em;
        padding-top: 0;
        padding-left: 3em;
        padding-right: 3em;
    }
    .sdata > * {
        flex: 1 1 0;
        display: flex;
    }
    .sdata > * > :first-child {
        flex: 0 0 9em;
        font-weight: 400;
    }
    .sdata > * > :last-child {
        flex: 1 1 0;
        font-weight: 500;
    }
</style>

<div class="card">
    <div class="card-title text-primary">
        {$_('Service discovery')}
        <button type="button" onclick={() => updateServices()} disabled={updating} class="btn btn-sm btn-outline-primary"><Icon inline icon="mdi:reload" /></button>
    </div>
    {#if $status != 'ready' || updating}
        <div class="card-body"><div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div></div>
    {:else if services && services.length}
        <div class="card-body">
            <ul class="list-group">
                {#each services as service}
                    <li class="list-group-item">
                        {serviceTexts[service] != null ? serviceTexts[service] : service}
                    </li>
                {/each}
            </ul>
        </div>
    {:else}
        <div class="card-body">Aucun services détecté.</div>
    {/if}

    {#if arcServices != null}
        <div class="card-body sdata">
            {#if arcServices.timeout}
                <div>
                    <span>Timeout</span>
                    <span class="text-danger">Oui, {arcServices.timeout_count}</span>
                </div>
            {:else}
                <div>
                    <span>Requête</span>
                    <span>{numberToVisual(arcServices.query_time, { nDecimals: 2, units: 's' })} / <Date value={arcServices.query_stamp} format="table-s" /></span>
                </div>
            {/if}
        </div>
    {/if}
</div>
